export enum ProductActivityUrlsEnum {
  GetActivitiesByProduct = "/api/ProductActivity/GetActivitiesByProduct",
}
